<template>
  <div id="notfound"
    class="notfound">
    <h1 class="notfound__headline">
      {{ $t('Looking_for_something_q') }}
    </h1>
    
    <h2 class="notfound__subline">
      {{ $t('We_are_sorry_c_the_page_you_requested_cannot_be_found') }}.
    </h2>

    <router-link :to="{ name: 'home'}"
      class="button primary large">
      {{ $t('Back_home') }}
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'notfound',

    head: {
      title: {
        inner: 'Merp! Not Found'
      }
    }
  }
</script>

<style lang="scss">
  @import '../scss/_variables.scss';
  @import '../scss/_functions.scss';

  .notfound {
    margin: {
      top: 4rem;
    }

    &__headline {
      color: palette(black);
      font: {
        size: 2rem;
        weight: 700;
      }
      margin: {
        top: 0;
        bottom: .5rem;
      }
    }

    &__subline {
      color: palette(gray);
      font: {
        size: 1.5rem;
        weight: 500;
      }
      margin: {
        top: 0;
        bottom: 2rem;
      }
    }

    a {
      text-decoration: none; 
    }
  }
</style>



// WEBPACK FOOTER //
// NotFound.vue?734bd5dc